/* eslint-disable no-template-curly-in-string */
import React, { useCallback } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {
	ApButtonSecondary,
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import { useState } from 'react';
import {
	ExploreButton,
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Title,
} from './ChartList.styles';
import { renderToString } from 'react-dom/server';
import Tooltip from '../../Components/Tooltip';
import filterNames, { generateToolTip } from 'utils/filterNames';
import {
	MultiSelectWrapper,
	RangeWrapper,
	SpendWrapper,
} from '../../WidgetSettings.js/WidgetSettings.styles';
import CategoryMultiSelect from 'Settings/FirstUsageSettings/CategoryMultiSelect';
import { useFilterContext } from 'contexts/FilterContext';
import { useChartContext } from 'contexts/CategoryChartContext';
import ExpandedModal from '../../Components/ExpandedModal';
import Slider from 'rc-slider';
import { Tooltip as RangeTooltip } from 'react-tippy';
import { TooltipContent } from '../../CategoryWidget.styles';

const BoxPlot = ({
	chartTitle,
	isParent,
	chartheight,
	xLabel,
	yLabel,
	boxplotSeriesName,
	scatterPlotSeriesName,
	chartDataBoxPlotData,
	chartDataScatterPlotData,
	xaxis,
	client,
}) => {
	const { state: newState, actions } = useFilterContext();
	const { setMultipleFilters } = actions;
	const { state } = useChartContext();
	const { boxplotclientLoading, boxplotblsLoading } = state;

	const [boxPlotSumSpendRange, setBoxPlotSumSpendRange] = useState(
		newState.boxWhiskerClientSumSpendOverJobTitleRange
	);

	const initialBoxPlotClientSettings = {
		[filterNames.boxWhiskerClientJobClass]: newState.boxWhiskerClientJobClass,
	};

	const initialBoxPlotSettings = {
		[filterNames.boxWhiskerBLSWorkerType]: newState.boxWhiskerBLSWorkerType,
		[filterNames.boxWhiskerBLSYear]: newState.boxWhiskerBLSYear,
	};

	const [boxPlotClientSettings, setBoxPlotClientSettings] = useState(
		initialBoxPlotClientSettings
	);
	const [boxPlotSettings, setBoxPlotSettings] = useState(
		initialBoxPlotSettings
	);

	const handleChange = useCallback((evnt, action, chart) => {
		if (action === 'jobClass' && chart === 'boxplot') {
			setBoxPlotClientSettings(prev => ({
				...prev,
				[filterNames.boxWhiskerClientJobClass]: evnt,
			}));
		}
		if (action === 'workerType' && chart === 'boxplotBls') {
			setBoxPlotSettings(prev => ({
				...prev,
				[filterNames.boxWhiskerBLSWorkerType]: evnt,
			}));
		}
		if (action === 'blsyear' && chart === 'boxplotBls') {
			setBoxPlotSettings(prev => ({
				...prev,
				[filterNames.boxWhiskerBLSYear]: evnt,
			}));
		}
	}, []);

	const chartDataOptions = [
		{
			name: boxplotSeriesName,
			type: 'boxplot',
			plotOptions: {
				series: {
					shadow: false,
				},
			},
			data: chartDataBoxPlotData?.map(obj => Object.values(obj)),
			tooltip: {
				shared: true,
				useHTML: true,
				backgroundColor: 'rgba(255,255,255, 0.9)',
				borderWidth: 0,
				borderRadius: 2,
				outside: true,
				pointFormatter: function() {
					const { options } = this;
					const tooltipData = generateToolTip(options);
					return renderToString(<Tooltip tooltipData={tooltipData} />);
				},
				headerFormat: '',
			},
		},
		{
			name: scatterPlotSeriesName,
			type: 'scatter',
			data: chartDataScatterPlotData,

			tooltip: {
				shared: true,
				useHTML: true,
				backgroundColor: 'rgba(255,255,255, 0.9)',
				borderWidth: 0,
				borderRadius: 2,
				outside: true,
				pointFormatter: function() {
					const { tooltip } = this;

					return renderToString(<Tooltip tooltipData={tooltip} />);
				},
			},
		},
		{
			name: `<span style="color:red">RateCard Max</span>`,
			type: 'column',
			data: chartDataScatterPlotData.map(obj => ({
				x: obj.x,
				y: obj.rateCardMax,
			})),
		},
	];
	const [isExpandedView, setIsExpandedView] = useState(false);

	const options = {
		chart: {
			type: 'boxplot',
			height: chartheight,
			zoomBySingleTouch: true,
			zoomType: 'xy',
		},
		exporting: { enabled: false, allowHTML: true },
		credits: { enabled: false },
		title: { text: '' },
		boost: {
			useGPUTranslations: true,
		},

		legend: {
			enabled: isParent ? false : true,
		},
		xAxis: {
			categories: xaxis,
			title: {
				text: xLabel,
			},
		},
		yAxis: {
			endOnTick: false,
			maxPadding: 0.1,
			title: {
				text: yLabel,
			},
			labels: {
				format: '${value}',
			},
			lineWidth: 1,
			gridLineWidth: 0,
		},
		tooltip: {
			useHTML: true,
			headerFormat: '',
		},
		plotOptions: {
			series: {
				animation: false,
			},
			scatter: {
				marker: {
					fillColor: '#448EB4',
					lineColor: '#AFE1FC',
					lineWidth: 1,
				},
				turboThreshold: 200000,
				animation: false,
			},
			column: {
				dataLabels: {
					enabled: true,
					color: 'red',
					style: {
						fontWeight: 'normal',
						fontSize: isParent ? '8px' : '12px',
						underline: true,
					},
				},
				color: 'rgba(255,255,255, 0)',
				animation: false,
			},
		},
		series:
			chartTitle === 'Bill Rate Range'
				? chartDataOptions
				: [chartDataOptions[0], chartDataOptions[1]],
		colors: ['#032E45', '#448EB4', '#45B9F7', '#AFE1FC'],
		animation: false,
	};
	return (
		<SectionWrapper>
			<Header>
				<Title>{isParent ? chartTitle : ''}</Title>
				{isParent && (
					<ExploreButton
						title="Explore"
						className="explore"
						onClick={() => setIsExpandedView(true)}
					>
						<ApIcon title="Explore" material={true} iconName="find_in_page" />
					</ExploreButton>
				)}
			</Header>
			{!isParent &&
				(client ? (
					<div style={{ display: 'flex' }}>
						<MultiSelectWrapper>
							<CategoryMultiSelect
								name="Job class"
								label="Job class"
								options={newState.jobClassOptions}
								selected={boxPlotClientSettings.boxWhiskerClientJobClass}
								onChange={e => handleChange(e, 'jobClass', 'boxplot')}
							/>
						</MultiSelectWrapper>
						<SpendWrapper>
							<span>Sum Spend over Title</span>
							<RangeWrapper>
								<RangeTooltip
									position="top"
									animation="fade"
									theme="light"
									arrow
									trigger="mouseenter"
									html={
										<TooltipContent>
											<span>Lower:</span>
											{boxPlotSumSpendRange[0]}
											{/* <br /> */} &nbsp;
											<span>Upper:</span> {boxPlotSumSpendRange[1]}
										</TooltipContent>
									}
									popperOptions={{
										modifiers: {
											preventOverflow: {
												enabled: true,
												boundariesElement: 'window',
											},
										},
									}}
								>
									<Slider
										range
										value={boxPlotSumSpendRange}
										min={newState.sumSpendOverRange[0]}
										max={newState.sumSpendOverRange[1]}
										allowCross={false}
										onChange={e => {
											setBoxPlotSumSpendRange([
												Math.floor(e[0]),
												Math.floor(e[1]),
											]);
											handleChange(e, 'sumspend', 'boxplot');
										}}
									/>
								</RangeTooltip>
							</RangeWrapper>
						</SpendWrapper>
						<ApButtonSecondary
							onClick={() => {
								const obj = {};
								for (const key in boxPlotClientSettings) {
									if (
										Array.isArray(boxPlotClientSettings[key]) &&
										boxPlotClientSettings[key].length > 0
									) {
										obj[key] = boxPlotClientSettings[key];
									}
								}
								setMultipleFilters({
									...obj,
									[filterNames.boxWhiskerClientSumSpendOverJobTitleRange]: boxPlotSumSpendRange,
								});
							}}
							style={{ marginLeft: 'auto' }}
						>
							Save
						</ApButtonSecondary>
					</div>
				) : (
					<div style={{ display: 'flex' }}>
						<MultiSelectWrapper>
							<CategoryMultiSelect
								name="Job class"
								options={newState.workerTypeOptions}
								selected={boxPlotSettings.boxWhiskerBLSWorkerType}
								label="Worker type"
								onChange={e => handleChange(e, 'workerType', 'boxplotBls')}
							/>
						</MultiSelectWrapper>
						<MultiSelectWrapper>
							<CategoryMultiSelect
								name="BLS Year"
								options={newState.blsYearOptions}
								selected={boxPlotSettings.boxWhiskerBLSYear}
								label="BLS Year"
								onChange={e => handleChange(e, 'blsyear', 'boxplotBls')}
							/>
						</MultiSelectWrapper>
						<ApButtonSecondary
							onClick={() => {
								const obj = {};
								for (const key in boxPlotSettings) {
									if (
										Array.isArray(boxPlotSettings[key]) &&
										boxPlotSettings[key].length > 0
									) {
										obj[key] = boxPlotSettings[key];
									}
								}
								setMultipleFilters(obj);
							}}
							style={{ marginLeft: 'auto' }}
						>
							Save
						</ApButtonSecondary>
					</div>
				))}
			{boxplotclientLoading === true || boxplotblsLoading === true ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{xaxis.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<>
							<HighchartsReact highcharts={Highcharts} options={options} />
						</>
					)}
					{isExpandedView && (
						<ExpandedModal
							heading={chartTitle}
							show={true}
							handleClose={() => setIsExpandedView(state => !state)}
						>
							<BoxPlot
								chartheight={'31%'}
								chartTitle={chartTitle}
								chartDataBoxPlotData={chartDataBoxPlotData}
								chartDataScatterPlotData={chartDataScatterPlotData}
								xaxis={xaxis}
								xLabel={xLabel}
								yLabel={yLabel}
								client={client}
								boxplotSeriesName={boxplotSeriesName}
								scatterPlotSeriesName={scatterPlotSeriesName}
							/>
						</ExpandedModal>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default React.memo(BoxPlot);
